import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/Slices/modalSlice';
import './scss/ZoobbePremiumCard.scss';
import Payments from '../icons/Payments';

const ZoobbePremiumCard = ({ workspaceId, planType = 'Premium', ctaMode = 'start_trial' }) => {
    const dispatch = useDispatch();

    const handleClick = (e) => {
        e.preventDefault();
        if (ctaMode === 'upgrade') {
            // Navigate to billing page to upgrade
            window.location.href = `/w/${workspaceId}/billing`;
        } else {
            // Default: open Start Trial modal
            dispatch(openModal({
                modalType: 'START_TRIAL',
                modalData: { workspaceId, planType }
            }));
        }
    };

    const ctaLabel = ctaMode === 'upgrade' ? 'Upgrade Pro' : 'Start free trial';

    return (
        <div className="zoobbe-premium-card">
            <h3 className="title">Try Zoobbe Premium</h3>
            <p className="description">
                Unlock advanced features, unlimited boards, and enhanced collaboration tools.
                Get unlimited storage and priority support to take your
                workspace to the next level.
            </p>
            <a href="#" onClick={handleClick} className="start-trial-link">
                {ctaLabel}
            </a>
            <div className="icon-container">
                <Payments />
            </div>
        </div>
    );
};

export default ZoobbePremiumCard;
